import React from 'react';
import { useOutletContext } from 'react-router-dom';
import SectionLabel from '../components/SectionLabel';
import FactGrid from '../components/FactGrid';
import { EmptyState } from '../components/Skeleton';
import { lighten } from '../data/meetings';
import { hotelFromEvent } from '../data/live';

export default function HotelPage() {
  const { meeting } = useOutletContext();
  const event = meeting._event;

  // Hotel fields live on the event row, which is already loaded by now.
  const hotel = hotelFromEvent(event);
  if (!hotel) {
    return <EmptyState>Hotel details will be posted here soon.</EmptyState>;
  }

  const heroGradient = `linear-gradient(135deg, ${meeting.color}, ${lighten(meeting.color, 0.2)}, ${meeting.accent})`;

  const facts = [
    { k: 'Check-in',     v: hotel.checkIn },
    { k: 'Check-out',    v: hotel.checkOut },
    { k: 'Rate',         v: hotel.rate },
    { k: 'Block closes', v: hotel.blockCloses },
  ];

  return (
    <>
      <div className="portal-hotel-hero" style={{ background: heroGradient }}>
        <div className="portal-hotel-hero-label">Host Hotel</div>
        <div className="portal-hotel-hero-name">{hotel.name}</div>
      </div>

      {hotel.tagline && <div className="portal-hotel-tagline">{hotel.tagline}</div>}

      <FactGrid items={facts} />

      <SectionLabel>Address</SectionLabel>
      <div className="portal-card">
        {hotel.address.map((line, i) => (
          <div key={i} className="portal-hotel-address-line">{line}</div>
        ))}
        {hotel.phone && <div className="portal-hotel-phone">{hotel.phone}</div>}
      </div>
    </>
  );
}
